import { message } from 'antd';
import { FETCH_TICKET_DETAILS_START, FETCH_TICKET_DETAILS_SUCCESS, FETCH_TICKET_DETAILS_ERROR, CREATE_TICKET, CREATE_TICKET_START, CREATE_TICKET_SUCCESS, CREATE_TICKET_ERROR, FETCH_COMMENTS, FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_ERROR, FETCH_COMMENTS_START, FETCH_TICKET_DETAILS, sortComments, ADD_COMMENT, ADD_COMMENT_START, ADD_COMMENT_SUCCESS, ADD_COMMENT_ERROR } from "../../actions/ticketing/ticketActions";
import { call, put, takeEvery, all, fork, takeLatest } from 'redux-saga/effects';
import { addCommentToDb, addTicketToDb, fetchCommentsFromDb, fetchTicketDetailsFromDb, raiseTicketAPI } from "../../../services/ticketing-service";
import { history } from "../../../appRedux/store";
import { UPDATE_TICKET_ID } from '../../actions/mis/reportViewerAction';

function* raiseTicket({ ticket }) {
    try {
        yield put({ type: CREATE_TICKET_START })
        const response = yield call(raiseTicketAPI, ticket);
        if (response.success) {
            yield put({ type: UPDATE_TICKET_ID, ticket: { ...response.ticketDetails, reportId: ticket.reportId } });
            yield put({ type: FETCH_TICKET_DETAILS_SUCCESS, ticket: { ...response.ticketDetails } });
            message.success("Ticket created successfully.");
            history.goBack();
        } else {
            if (response.error && typeof error === 'string') {
                yield put({ type: CREATE_TICKET_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: CREATE_TICKET_ERROR, error: response.error })
                message.error("Error occured while creating ticket!");
            }
        }
    } catch (error) {
        yield put({ type: CREATE_TICKET_ERROR, error })
        message.error("Error occured while creating ticket!");
    }
}


function* fetchTicketDetails(data) {
    try {
        const response = yield call(fetchTicketDetailsFromDb, data.params);
        yield put({ type: FETCH_COMMENTS, params: data.params  })
        if (response.data.success) {
            yield put({ type: FETCH_TICKET_DETAILS_SUCCESS, ticket: response.data.ticketDetails })
        } else {
            yield put({ type: FETCH_TICKET_DETAILS_SUCCESS, ticket: null })
            message.error('Failed to fetch ticket details!');
        }
    } catch (error) {
        yield put({ type: FETCH_TICKET_DETAILS_ERROR, error })
        message.error('Failed to fetch ticket details!');
    }
}

function* addComment({ comment }) {
    try {
        yield put({ type: ADD_COMMENT_START })
        const response = yield call(addCommentToDb, comment);
        if (response.data.success) {
            yield put({ type: FETCH_COMMENTS, params: { clientId: comment.clientId, ticketId: comment.ticketId }  })
            yield put({ type: ADD_COMMENT_SUCCESS })
            message.success("Comment to the ticket added successfully.");
        } else {
            yield put({ type: ADD_COMMENT_ERROR, error: response.data.error })
            message.warning("Error occured while adding comment!");
        }
    } catch (error) {
        yield put({ type: ADD_COMMENT_ERROR, error })
        message.warning("Error occured while adding comment!");
    }
}

function* fetchComments(data) {
    try {
        yield put({ type: FETCH_COMMENTS_START })
        const response = yield call(fetchCommentsFromDb, data.params);
        if (response.data.success) {
            const sortedComments = sortComments(response.data.comments);
            yield put({ type: FETCH_COMMENTS_SUCCESS, comments: sortedComments })
        } else {
            yield put({ type: FETCH_COMMENTS_ERROR, error: response.data.error })
            message.error('Failed to fetch comments!');
        }
    } catch (error) {
        yield put({ type: FETCH_COMMENTS_ERROR, error })
        message.error('Failed to fetch comments!');
    }
}

function* ticketWatcher() {
    yield takeLatest(CREATE_TICKET, raiseTicket)
    yield takeLatest(ADD_COMMENT, addComment)
    yield takeEvery(FETCH_TICKET_DETAILS, fetchTicketDetails)
    yield takeEvery(FETCH_COMMENTS, fetchComments)
}

export default function* rootSaga() {
    yield all([
        ticketWatcher(),
    ]);
}